import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import {device} from '../../theme/breakpoints'

export const StyledDrawerNavbar = styled.nav`
  position: fixed;
  z-index: 100;
  top: ${pxToRem(50)};
  bottom: 0;
  left: 0;
  right: ${pxToRem(48)};
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  display: ${({$isOpen}) => $isOpen ? 'flex' : 'none'};
  padding-top: 0.5rem;
  color: ${({theme}) => theme.colors.unique.white};
  background-color: ${({theme}) => theme.colors.unique.black};

  @media ${device.tablet} {
    right: ${pxToRem(300)};
  }

  @media ${device.laptop} {
    display: none;
  }
`

export const StyledDrawerMainList = styled.ul`
  display: block;
  overflow-y: auto;
  width: 100%;
  padding-top: ${pxToRem(12)};
  padding-right: ${pxToRem(33)};

  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
`

export const StyledDrawerSubList = styled.ul``
